import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonToolbar,
  Button,
  Modal
} from 'react-bootstrap';
import { findById } from '../../../core/utils';
import { tourType } from './CatchPropTypes';
import TourRouteTable from './TourRouteTable';
import EventDetailModal from './EventDetailModalContainer';
import EventFilterToolbar from './EventFilterToolbar';
import { EVENT_NAMES } from './EventStyles';
import { fullDate, shortDate, monthNameFormatDate, shortMonthNameFormatDate } from '../../../core/date';

class TourRouteTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showConfirm: false,
      tourIdForReference: 0,
      modalText: '',
      route:[]
    };
    this.handleAdd = this.handleAdd.bind(this);
    this.getToolbar = this.getToolbar.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.showEvent = this.showEvent.bind(this);
    this.clearRoute = this.clearRoute.bind(this);
    this.showConfirmForClearRoute = this.showConfirmForClearRoute.bind(this);
    this.updateRoute = this.updateRoute.bind(this);
    this.formatTourStops = this.formatTourStops.bind(this);
    this.formatEvent = this.formatEvent.bind(this);
    this.formatRelatedEvent = this.formatRelatedEvent.bind(this);
    this.formatDate = this.formatDate.bind(this);
    this.formatTime = this.formatTime.bind(this);
  }

  componentDidMount() {
    let routList = this.formatTourStops();
    this.setState({
      route: routList
    });
  }
 //Function to update the stay dates after updating related event
 updateRoute(event){
   const tourStopsToUpdate = this.props.tour.tour_stops;
   for (let i = 0, len = tourStopsToUpdate.length; i < len; i++) {
     if (tourStopsToUpdate[i].id == event.id) {
       this.props.tour.tour_stops[i] = event;
       break;
     }
   }

   let routList = this.formatTourStops();
   this.setState({
      route: routList
    });
  }

  formatTime(duration) {
    return duration.substring(0, duration.lastIndexOf(':'));
  }

  formatDate(event) {
    if (event.event_type === 'stay') {
      return `${shortMonthNameFormatDate(event.bids.bid_details.length > 0 ? 
        (event.bids.bid_details[0].lowest_check_in_date ? 
            event.bids.bid_details[0].lowest_check_in_date : event.start) : 
        event.start
    )} - ${monthNameFormatDate(event.bids.bid_details.length > 0 ? 
      (event.bids.bid_details[0].greatest_check_out_date ? 
          event.bids.bid_details[0].greatest_check_out_date : event.end) : 
      event.end
  )}`;
    }else if(event.event_type !== 'stay' && event.start != event.end) {
      return `${shortMonthNameFormatDate(event.start)} - ${monthNameFormatDate(event.end)}`;
    }
    return monthNameFormatDate(event.start);
  }

  formatRelatedEvent(event, events, parent, filter) {
    if (filter[event.group_name] || event.place == null) {
      return;
    }
    let location;
    let nameVal;
    if (event.place) {
      if (event.place.city == null){
          location = `${event.place.state}, ${event.place.country}`;
          nameVal = `${event.place.state}, ${event.place.country}`;
        }
        if (event.place.state == null){
          location = `${event.place.city}, ${event.place.country}`;
          nameVal = `${event.place.city}, ${event.place.country}`;
        }
        if (event.place.city == null && event.place.state == null){
          location = `${event.place.country}`;
          nameVal = `${event.place.country}`;
        }
        if (event.place.city == null && event.place.state == null && event.place.country == null){
          location = ' ';
          nameVal = ' ';
        }
        if(event.place.city != null && event.place.state != null && event.place.country != null){
          if (event.place.city === event.place.state){
            location = `${event.place.city}, ${event.place.country}`;
            nameVal = `${event.place.city}, ${event.place.country}`;
          } else{
              if(event.place.state === event.place.country){
                  location = `${event.place.city}, ${event.place.country}`;
                  nameVal = `${event.place.city}, ${event.place.country}`;
          }   else {
                  location = `${event.place.city}, ${event.place.state}, ${event.place.country}`;
                  nameVal = `${event.place.city}, ${event.place.state}`;
              }
           }
        }
    } else{
      location = " ";
      name = " "
    }
    name = `${event.group_name} @ ${nameVal}`;
    if (event.bids.hotel) {
      name = `${event.group_name} @ ${event.bids.hotel.name}`;
      location = `${event.bids.hotel.city}, ${event.bids.hotel.state}`;
    }
    const dates = this.formatDate(event);
    events.push({
      id: parent.id,
      date: dates,
      name,
      event_type: event.event_type,
      location,
      driveTime: this.formatTime(parent.duration_to_next),
      image: event.event_type,
      notes: event.notes,
    });
  }

  formatEvent(event, events, filter) {
    if (event.event_type === 'stay') {
      if (filter[event.event_type]) {
        return;
      }
      const relatedEvents = event.related_group_events;
      for (let i = 0, len = relatedEvents.length; i < len; i++) {
        if (event.id==relatedEvents[i].parent){
           relatedEvents[i]["notes"] =event.notes
        }
        this.formatRelatedEvent(relatedEvents[i], events, event, filter);
      }
    } else {
      if (filter[event.event_type]) {
        return;
      }
      const dates = this.formatDate(event);
      let location;
      if (event.place) {
        if (event.place.city == null){
          location = `${event.place.state}, ${event.place.country}`;
        }
        if (event.place.state == null){
          location = `${event.place.city}, ${event.place.country}`;
        }
        if (event.place.country == null){
          location = `${event.place.city}, ${event.place.state}`;
        }
        if (event.place.city == null && event.place.state == null){
          location = `${event.place.country}`
        }
        if (event.place.city == null && event.place.state == null && event.place.country == null){
          location = ' '
        }
        if(event.place.city != null && event.place.state != null && event.place.country != null){
          if (event.place.city === event.place.state){
            location = `${event.place.city}, ${event.place.country}`;
          } else{
              if(event.place.state === event.place.country){
                  location = `${event.place.city}, ${event.place.country}`;
              }else {
                  location = `${event.place.city}, ${event.place.state}, ${event.place.country}`;
          }
        }
        }
      }
      const name = event.name ? event.name : EVENT_NAMES[event.event_type];
      events.push({
        id: event.id,
        date: dates,
        name,
        event_type: event.event_type,
        location,
        image: event.event_type,
        notes: event.notes,
      });
    }
  }

  formatTourStops(){
    let routList = [];
    const data= this.props.proposals.length>0?this.props.proposals[0].tour.tour_stops:this.props.tour.tour_stops
    data.forEach((event) => {
      this.formatEvent(event, routList, this.props.filter);
      if (event.events) {
        for (let i = 0, len = event.events.length; i < len; i += 1) {
          this.formatEvent(event.events[i], routList, this.props.filter);
        }
      }
    });
    return routList;
  }

  getToolbar(readOnly) {
    if (readOnly) {
      return null;
    }
    // console.log(this.props.tour.state);
    const state = (this.props.tour.state === 'DR' && this.props.tour.tour_stops.length > 0);
    const add = <Button bsStyle="success" onClick={this.handleAdd}><i className="fa fa-plus" /> Add</Button>;

    return (
      <ButtonToolbar>{ add }
        {state && (
        <Button bsStyle="danger" onClick={this.showConfirmForClearRoute}>
          <i className="fa fa-trash" /> Clear Route
        </Button>
        )}
        <EventFilterToolbar
          groups={this.props.tour.groups}
          filter={this.props.filter}
          eventFilterSet={this.props.eventFilterSet}
        />
      </ButtonToolbar>);
  }
  clearRoute() {  
    this.props.clearRoute(this.state.tourIdForReference);
    this.setState({
      showConfirm: false,
      tourIdForReference: 0,
      modalText: ''
    });
  }
  showConfirmForClearRoute() {   
    this.setState({
      showConfirm: true,
      tourIdForReference: this.props.tour.id,
      'modalText': "This will erase your routing and all hotel bids from the program.  Are you sure you want to delete routing?"
    }); 
  }
  handleAdd(e) {
    e.preventDefault();
    this.setState({
      event: -1,
      show: true,
    });
  }  

  findEvent(id) {
    // New EVENT
    if (id === -1) {
      return { tour: this.props.tour.id, all_day: true };
    }
    const stops = this.props.tour.tour_stops;
    for (let i = 0, len = stops.length; i < len; i++) {
      console.log('stop id, id => ', stops[i].id, id)
      if (stops[i].id === Number(id)) {
        return this.props.tour.tour_stops[i];
      }
      const idx = stops[i].events.findIndex(findById, id);
      if (idx !== -1) {
        return this.props.tour.tour_stops[i].events[idx];
      }
    }
    console.log('that should not happen... findEvent: ', id);
    return { tour: this.props.tour.id, all_day: true };
  }
  showEvent(e) {
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data-item');
    if (id) {
      console.log('show event: ', id);
      this.setState({
        event: id,
        show: true,
      });
    }
  }
  closeModal() {
    this.setState({
      show: false,
      event: null,
      showConfirm: false,
      tourIdForReference: 0,
      modalText: ''
    });
  }
  render() {
    const toolbar = this.getToolbar(this.props.readOnly);
    return (
      <div className="col-sm-12 planner">
        {toolbar}
        { this.state.show && (
        <EventDetailModal
          event={this.findEvent(this.state.event)}
          show={this.state.show}
          onClose={this.closeModal}
          editing={!this.props.readOnly}
          postEventDeleteAction={this.postEventDeleteAction}
          tourStops={this.props.tour.tour_stops}
          updateRoute={this.updateRoute}
          postEventAddAction={this.postEventAddAction}
        />
        )}
        <TourRouteTable
          tourStops={this.props.tour.tour_stops}
          showEvent={this.showEvent}
          filter={this.props.filter}
          route={this.state.route}
          formatTourStops={this.formatTourStops}
        />

        {this.state.showConfirm && (<Modal show={this.state.showConfirm} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Clear Route</Modal.Title>
          </Modal.Header>
          <Modal.Body>

             <p> {this.state.modalText !== '' ? this.state.modalText : 'Are you sure want to clear routes?'}</p>

             <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={this.clearRoute}
              >
                Confirm
              </Button>
              <Button
                bsStyle="success"
                onClick={this.closeModal}
              >
                Cancel
              </Button>
            </ButtonToolbar><br/>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}

      </div>
    );
  }
}
TourRouteTab.propTypes = {
  tour: PropTypes.shape(tourType).isRequired,
  places: PropTypes.arrayOf(PropTypes.object).isRequired,
  filter: PropTypes.object.isRequired,
  addEvent: PropTypes.func.isRequired,
  editEvent: PropTypes.func.isRequired,
  removeEvent: PropTypes.func.isRequired,
  eventFilterSet: PropTypes.func.isRequired,
  clearRoute: PropTypes.func.isRequired,
  requestPlaceOptions: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};
TourRouteTab.defaultProps = {
  readOnly: false,
};
export default TourRouteTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRouteTab.js